import { AosSeverity, isSeverityInkDark } from 'aos-services/src/services/common/types/AosSeverity'
import { IconVariant } from 'aos-ui/src/components/svg/Icon'

interface TaskRef {
    severity: AosSeverity
}

export function taskItemIconVariant(inTooltip: boolean, item: TaskRef) {
    return inTooltip || isSeverityInkDark(item.severity) ? IconVariant.Black : IconVariant.White
}
